<template>
  <div>
    <page-body>
      <page-header :title="$t('scope.text_296')" />
      <invoice-application-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import InvoiceApplicationManagerList from './components/List'

export default {
  name: 'InvoiceApplicationManagerIndex',
  components: {
    InvoiceApplicationManagerList,
  },
  data () {
    return {
      listId: 'InvoiceApplicationManagerList',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
